import { ICenterCompliance } from './center-compliance';
import { IComplianceLog } from './compliance-log';
import { IDeleteNdd } from './delete-ndd';
import { IDonorCompliance } from './donor-compliance';
import { ILateCryo } from './late-cryo';
import { ILateSerology } from './late-serology';
import { IRccap } from './rccap';
import { IRecipientCompliance } from './recipient-compliance';
import { IRelativePerformance, IRpChainEndDeclineRatio } from './relative-performance';
import { IScoreCard } from './score-card';
import { IPreselectStatistics } from './pre-select-statistics';
import { IMicrositeRecipientCompliance } from './microsite-recipient-compliance';
import { IDonorWithRemoteRecipient } from './donor-with-remote-recipient';
import { IDonorWithMSRecipientUpdated } from './donors-with-remote-recipient-updated';
import { RmcrType } from './rmcr-type';
import { IStrongBoxComplianceItem } from './strongbox-compliance-item';
import { IDashDonorsPendingRemoteStatus } from './dash-donors-pending-remote-status';

interface ICenterPerformanceCompliance {
    complianceLog: IComplianceLog,
    centerCompliance: ICenterCompliance,
    recipientCompliance: IRecipientCompliance[],
    dashRemoteStatusCompliance: IDashDonorsPendingRemoteStatus[],
    postTxpRecipientCompliance: IRecipientCompliance[],
    donorCompliance: IDonorCompliance[],
    postTxpDonorCompliance: IDonorCompliance[],
    rdnDonorCompliance: IDonorCompliance[],
    postTxpRdnDonorCompliance: IDonorCompliance[],
    micrositeCompliance: IMicrositeRecipientCompliance[],
    recipientCount: number,
}

interface ICenterPerformanceImmediateAttention {
    deleteNddList: IDeleteNdd[],
    rccapList: IRccap[],
    lateSerologyList: ILateSerology[],
    lateCryoList: ILateCryo[],
    immediateAttentionCount: number,
}

interface ICenterPerformance {
    centerId: number,
    centerAlias: string,
    nkrLiaisonName: string,
    nkrLiaisonEmail: string,
    centerCompliance: ICenterCompliance,
    recipientCompliance: IRecipientCompliance[],
    dashRemoteStatusCompliance: any[],
    postTxpRecipientCompliance: IRecipientCompliance[],
    donorCompliance: IDonorCompliance[],
    postTxpDonorCompliance: IDonorCompliance[],
    rdnDonorCompliance: IDonorCompliance[],
    postTxpRdnDonorCompliance: IDonorCompliance[],
    micrositeCompliance: IMicrositeRecipientCompliance[],
    DonorWithRemoteRecipient: IDonorWithRemoteRecipient[],
    deleteNddList: IDeleteNdd[],
    rccapList: IRccap[],
    lateSerologyList: ILateSerology[],
    lateCryoList: ILateCryo[],
    relativePerformance: IRelativePerformance,
    immediateAttentionCount: number,
    memberCenterCount: number
}

export {
    ICenterPerformance,
    ICenterCompliance,
    IComplianceLog,
    IDeleteNdd,
    IDonorCompliance,
    ILateCryo,
    ILateSerology,
    IRccap,
    IRecipientCompliance,
    IRelativePerformance,
    IScoreCard,
    IPreselectStatistics,
    RmcrType,
    IMicrositeRecipientCompliance,
    IDonorWithRemoteRecipient,
    IDonorWithMSRecipientUpdated,
    IStrongBoxComplianceItem,
    ICenterPerformanceImmediateAttention,
    ICenterPerformanceCompliance,
    IRpChainEndDeclineRatio,
    IDashDonorsPendingRemoteStatus
}